var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"theme",staticClass:"app-theme",style:(_vm.themeStyle),attrs:{"id":"app-theme"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }